class i {
  static factor(r, t) {
    const l = r.servingSize ?? 0;
    return !l || !t ? 0 : t / l;
  }
  static adjustedNutrition(r, t) {
    const l = r.nutritionalInfo ?? {}, n = this.factor(r, t);
    return r.servingSize ? {
      calories: l.energyKcal != null ? l.energyKcal * n : null,
      protein: l.protein != null ? l.protein * n : null,
      carbs: l.carbs != null ? l.carbs * n : null,
      fats: l.fats != null ? l.fats * n : null,
      fiber: l.fibre != null ? l.fibre * n : null,
      water: l.waterMl != null ? l.waterMl * n : null
    } : {
      calories: l.energyKcal ?? null,
      protein: l.protein ?? null,
      carbs: l.carbs ?? null,
      fats: l.fats ?? null,
      fiber: l.fibre ?? null,
      water: l.waterMl ?? null
    };
  }
  static toItemProps(r, t) {
    return {
      servingUnit: r.servingUnit ?? null,
      ...this.adjustedNutrition(r, t)
    };
  }
}
export {
  i as MealUtils
};
